import COLORS from '../../utils/constants/colors'

const gameDrawerTabsStyles = () => ({
  root: {
    display: 'flex',
    alignItems: 'flex-end',
    borderBottom: '1px solid #ECECEC',
    marginBottom: 24,
  },
  tab: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    cursor: 'pointer',
    userSelect: 'none',
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: '.02em',
    color: '#9A9A9A',
    background: 'none',
    border: 'none',
    outline: 'none',
    transition: 'color .15s ease',
  },
  tabActive: {
    color: '#3C3C3C',
  },
  tabDisabled: {
    color: '#C8C8C8',
    cursor: 'not-allowed',
  },
  // Wrapper so the Tooltip still receives hover events over a disabled button.
  tooltipWrap: {
    display: 'inline-flex',
  },
  underline: {
    position: 'absolute',
    left: 8,
    right: 8,
    bottom: -1,
    height: 2,
    borderRadius: '2px 2px 0 0',
    backgroundColor: COLORS.coral,
    opacity: 0,
    transition: 'opacity .15s ease',
  },
  underlineActive: {
    opacity: 1,
  },
  dot: {
    width: 6,
    height: 6,
    marginLeft: 6,
    borderRadius: '50%',
    backgroundColor: COLORS.coral,
  },
  // Error dot shares the reserved slot with the coral dot but takes visual precedence.
  dotError: {
    backgroundColor: COLORS.red,
  },
  // Keeps the dot's layout space reserved while hidden, so appearing/disappearing
  // never nudges the neighbouring tabs.
  dotHidden: {
    visibility: 'hidden',
  },
})

export default gameDrawerTabsStyles
